import React, { useContext } from "react"
import styled from "styled-components"
import { GlobalContext } from "../context/GlobalState"

import { MdClose } from "react-icons/md"

export const BagItem = ({ bagItem }) => {
  const { removeFromBag } = useContext(GlobalContext)

  return (
    <Item>
      <TitleContainer>
        <h1>{bagItem.title}</h1>
        <button onClick={() => removeFromBag(bagItem.id)}>
          <MdClose />
        </button>
      </TitleContainer>
      <p>{bagItem.size}</p>
      <p>{bagItem.price}</p>
    </Item>
  )
}

const Item = styled.div`
  :not(:first-child) {
    margin-top: 3vh;
  }

  h1 {
    font-family: "julius sans one", serif;
    /* font-size: clamp(1.7rem, 1vw, 2.5rem); */
    font-size: 1.7rem;
    font-weight: normal;
    margin-left: -2.5px;
  }

  p {
    /* font-family: "lato", sans-serif; */

    :nth-child(3) {
      font-size: 0.9rem;
    }
  }

  button {
    background: none;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.1rem;
    color: #808080;
    transition: 300ms;
    cursor: pointer;

    :hover {
      color: red;
    }
  }
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 2.5px;
`
